import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { ApiService } from '@app/shared';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(protected api: ApiService, protected router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.api
      .user$.pipe(
        switchMap(user => {
          if (user && user.role === 'admin') {
            return of(true);
          }

          if (user) {
            return this.router.navigate(['/']);
          }

          return this.router.navigate(['/login'], {
            queryParams: {
              ret: state.url
            }
          });
        })
      );
  }

}
